import React from "react";
import { useTranslation } from "react-i18next";

function CTASection({ onNavigate }) {
  const { t } = useTranslation();
  return (
    <div className="cta-container">
      <button className="CTA-nav-btn" onClick={onNavigate}>
        {t("Découvrir les clubs")}
      </button>
      <div className="CTA-nav-reflection"></div>
    </div>
  );
}

export default CTASection;
